import { Form, Formik, FormikHelpers } from "formik";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { WebCourseFormValues } from "src/models/WebCourse.model";
import { useEditWebcourseMutation } from "src/services/WebcourseServices";
import { showToast } from "src/utils/showToaster";
import { array, object, string } from "yup";
import AdditionalDescriptionForm from "./AdditionalDescriptionForm";

const AdditionalDescriptionFormWrapper = () => {
  const [updateWebCourse] = useEditWebcourseMutation();
  const { webCourseDataLayout }: any = useOutletContext();

  const { id = "" } = useParams();
  const navigate = useNavigate();


  // Form Initial Values
  const initialValues: WebCourseFormValues = {
    courseName: webCourseDataLayout?.courseName || '',
    color: webCourseDataLayout?.color || '',
    rating: webCourseDataLayout?.overallRating || '',
    skills: webCourseDataLayout?.skills?.map((el: any) => ({
      label: el || '',
      value: el || ''
    })) || [],
    totalReview: webCourseDataLayout?.totalReview || '',
    requirement: webCourseDataLayout?.requirement || ''
  };

  // Validation Schema
  const validationSchema = object().shape({
    rating: string().required("Please enter rating"),
    color: string().required("Please enter color"),
    totalReview: string().required("Please enter totalReview"),
    requirement: string().required("Please enter requirement"),
    skills: array().min(1, "Please select skill").required('Please select skill'),
  });

  // Handle Submit
  const handleSubmit = (
    values: WebCourseFormValues,
    { setSubmitting, resetForm }: FormikHelpers<WebCourseFormValues>
  ) => {
    const formatedValue = {
      courseName: values.courseName || '',
      color: values.color || '',
      skills: values?.skills?.map((skill: any) => skill?.value) || [],
      requirement: values?.requirement || '',
      totalReview: values?.totalReview || '',
      overallRating: values?.rating || '',
    };

    updateWebCourse({ body: formatedValue, id: id }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          navigate('/website-content/web-course')
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formikProps) => (
        <Form className="h-full overflow-hidden contents">
          <AdditionalDescriptionForm formikProps={formikProps} />
        </Form>
      )}
    </Formik>
  );
};

export default AdditionalDescriptionFormWrapper;
